var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Default(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 4.68652,
    width: 22.6274,
    height: 22.6274,
    rx: 2,
    fill: "#A7A9BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 22.6274,
    height: 22.6274,
    rx: 2,
    transform: "rotate(-45 0 16)",
    fill: "#A7A9BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.058L16.584 16.278C16.948 15.9047 17.2327 15.5827 17.438 15.312C17.6433 15.032 17.788 14.7753 17.872 14.542C17.9653 14.3087 18.012 14.066 18.012 13.814C18.012 13.3193 17.8533 12.932 17.536 12.652C17.2187 12.372 16.808 12.232 16.304 12.232C15.8093 12.232 15.3753 12.3533 15.002 12.596C14.6287 12.8293 14.2973 13.1933 14.008 13.688L13.084 12.918C13.4667 12.2833 13.9287 11.8073 14.47 11.49C15.0113 11.1633 15.6367 11 16.346 11C16.9433 11 17.4613 11.1167 17.9 11.35C18.348 11.5833 18.6933 11.91 18.936 12.33C19.1787 12.75 19.3 13.24 19.3 13.8C19.3 14.2013 19.2487 14.5607 19.146 14.878C19.0527 15.1953 18.88 15.522 18.628 15.858C18.3853 16.1847 18.0447 16.5767 17.606 17.034L14.708 20.016L13 20.058ZM13 20.856V20.058L14.12 19.68H19.524V20.856H13Z",
    fill: "#F8F7FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Default);
export default __webpack_public_path__ + "static/media/2-default.8d1efcac5301f342d2ca5f74615c2d27.svg";
export { ForwardRef as ReactComponent };